// extracted by mini-css-extract-plugin
module.exports = {"mainDivVideo":"bio-css_mainDivVideo__2gXCH","video":"bio-css_video__138P4"};